<div class="spinner-wrapper" [ngClass]="rootCssClass">
  <div class="spinner-border" [ngClass]="spinnerSize"></div>
</div>
